// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionSubHeader_wrapper__29nMP","sectionSubHeader":"SectionSubHeader_sectionSubHeader__2ekzH","sectionToggle":"SectionSubHeader_sectionToggle__2ltoe"};